import { ClientAPI } from '@/redux/api';
import {
  TrackingProfile,
  UserProfile,
  ContractStatuses,
  ContractDiscountsExtended
} from '@/@types/client-api';

const userProfileEndpoints = ClientAPI.injectEndpoints({
  endpoints: builder => ({
    getUserProfile: builder.query<UserProfile, void>({
      query: () => ({
        url: '/user/profile',
        method: 'GET'
      })
    }),
    updateUserProfile: builder.mutation<UserProfile, UserProfile>({
      query: body => ({
        url: '/user/profile',
        method: 'PUT',
        body
      }),
      invalidatesTags: ['CreditTrackerData']
    }),
    getUserTrackingProfile: builder.query<TrackingProfile, void>({
      query: () => ({
        url: '/user/tracking-profile',
        method: 'GET'
      })
    }),
    getUserContractStatuses: builder.query<ContractStatuses, void>({
      query: () => ({
        url: '/user/contract/statuses',
        method: 'GET'
      })
    }),
    getUserContractDiscountsExtendedUncached: builder.query<ContractDiscountsExtended, void>({
      query: () => ({
        url: '/user/contract/discounts-extended-uncached',
        method: 'GET'
      })
    })
  })
});

export const {
  useGetUserProfileQuery,
  useUpdateUserProfileMutation,
  useGetUserTrackingProfileQuery,
  useLazyGetUserContractStatusesQuery,
  useGetUserContractStatusesQuery,
  useGetUserContractDiscountsExtendedUncachedQuery
} = userProfileEndpoints;

export default userProfileEndpoints;
